import React, { useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { AppErrorList } from '../../../shared/components/AppErrorList';
import BearerBoxInfo from '../components/BearerBoxInfo';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import {
  selectBearerboxByServerId
, selectErrorsForBearerbox
, selectIsLoadingBearerbox
} from '../../../store/bearerbox/bearerboxSelector';
import { fetchBearerboxByServerId, fetchBearerboxIfOutdated } from '../../../store/bearerbox/bearerboxActions';

interface Props {
  readonly serverId: string;
}

const BearerboxContainer = (props: Props) => {
  const { serverId } = props;
  const dispatch = useAppDispatch();

  const loading = useAppSelector(state => selectIsLoadingBearerbox(state, serverId));
  const errors = useAppSelector(state => selectErrorsForBearerbox(state, serverId));
  const bearerbox = useAppSelector(state => selectBearerboxByServerId(state, serverId));

  const handleRefreshStatus = () => {
    dispatch(fetchBearerboxByServerId(serverId));
  };

  useEffect(() => {
    dispatch(fetchBearerboxIfOutdated(serverId));
  }, [dispatch, serverId]);

  if (loading) {
    return <CircularProgress size={20} />;
  }

  if (errors.length > 0) {
    return <AppErrorList errors={errors} />;
  }

  return (
    <BearerBoxInfo
      status={bearerbox?.status}
      storeStatus={bearerbox?.storeStatus}
      onRefreshStatus={handleRefreshStatus}
    />
  );
}

export default BearerboxContainer;
